module.exports = __webpack_public_path__ + "spine/Farm_Boy.json?3239ef7554050aac962c1971949b7afb";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spine/citizens/boy/Farm_Boy.json
// module id = 1745
// module chunks = 3